module.exports = __webpack_public_path__ + "img/backhoe_parked.82c054d0.svg";